import { useEffect, useRef } from "react";
import { Box, Flex, IconButton, Tab, TabList, Text, useColorModeValue } from "@chakra-ui/react";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { styles } from "../../../OrganizationQuestionnaire/components/Categories/components/Steps/TabStepsList";

function LocationsTabList({ currentIndex, locations, tabsCollapsed, setTabsCollapsed }) {
  const listRef = useRef();
  const selectedTabRef = useRef();
  const submitBtnRef = useRef();

  const timelineBg = useColorModeValue("gray.200", "gray.700");

  const indicatorBg = useColorModeValue("white", "gray.800");
  const indicatorSelectedBg = "esg_active";
  const indicatorColor = useColorModeValue("black", "white");
  const indicatorRing = useColorModeValue(
    `0 0 0 0.5rem var(--chakra-colors-white)`,
    `0 0 0 0.5rem var(--chakra-colors-gray-800)`
  );

  useEffect(() => {
    const selectedTab = selectedTabRef.current;
    const tabList = listRef.current;

    if (tabList && selectedTab) {
      tabList.scrollTop = selectedTab.offsetTop;
    }
  }, [currentIndex]);

  return (
    <>
      <button ref={submitBtnRef} type="submit" form={`formStep${locations[currentIndex].id}`} />
      <TabList
        {...styles.tabList({ tabsCollapsed, timelineBg })}
        ref={listRef}
      >
        {locations.map((location, index) => {
          const isSelected = currentIndex === index;
          return (
            <Tab
              key={`tab_${location.id}`}
              {...styles.tab({ focusColor: indicatorSelectedBg })}
              ref={(el) => {
                if (isSelected) {
                  selectedTabRef.current = el;
                }
              }}
            >
              <Box {...styles.tabContent} onClick={() => submitBtnRef.current.click()}>
                <Box
                  {...styles.tabIndicator({
                    isSelected,
                    indicatorBg,
                    indicatorSelectedBg,
                    indicatorColor,
                    indicatorRing
                  })}
                >
                  {index + 1}
                </Box>
                <Text as="strong" {...styles.tabTitle({ isSelected })}>
                  {location.supplierName}
                </Text>
                <Text as="span" {...styles.tabSubTitle({ isSelected })}>
                  {location.location}
                </Text>
              </Box>
            </Tab>
          );
        })}
        <Tab {...styles.collapseTab({ bg: indicatorBg })}>
          <Flex inlineSize="full">
            <IconButton
              onClick={() => setTabsCollapsed((prev) => !prev)}
              variant="outline"
              size="xs"
              icon={tabsCollapsed ? <FaArrowRight /> : <FaArrowLeft />}
            />
          </Flex>
        </Tab>
      </TabList>
    </>
  );
}

export default LocationsTabList;
